import { createRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { appRoute } from "../shell/routes";
import { NotificationsPage } from "./NotificationsPage";
import { AccountsPage } from "./AccountsPage";
import { ProfilePage } from "./ProfilePage";
import { SendersPage } from "./SendersPage";
import { WorkspaceDetailPage } from "./WorkspaceDetailPage";
import { WorkspacesPage } from "./WorkspacesPage";

export const workspacesSettingsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "settings/workspaces",
  component: WorkspacesPage,
});

export const workspaceSettingsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "settings/workspaces/$workspaceId",
  component: function WorkspaceSettings() {
    const { workspaceId } = workspaceSettingsRoute.useParams();
    return <WorkspaceDetailPage key={workspaceId} workspaceId={workspaceId} />;
  },
});

/** Settings → Profile: the person's own name (WP-029). */
export const profileSettingsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "settings/profile",
  component: ProfilePage,
});

export const notificationsSettingsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "settings/notifications",
  component: NotificationsPage,
});

/** Settings → Senders: the person's sender corrections (WP-063). */
export const sendersSettingsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "settings/senders",
  component: SendersPage,
});

const AccountsSearch = z.object({
  connected: z.string().min(1).max(100).optional().catch(undefined),
  error: z.string().min(1).max(100).optional().catch(undefined),
});

/** Settings → Mail accounts; the OAuth callback returns here with `?connected=` or `?error=`. */
export const accountsSettingsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "settings/accounts",
  validateSearch: (raw: Record<string, unknown>) => AccountsSearch.parse(raw),
  component: function AccountsSettings() {
    const { connected, error } = accountsSettingsRoute.useSearch();
    const navigate = useNavigate({ from: accountsSettingsRoute.fullPath });
    return <AccountsPage connected={connected} error={error} onDismiss={() => void navigate({ search: {}, replace: true })} />;
  },
});
